import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShield = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.92578 18.6314C12.0319 17.6781 17 14.7333 17 8.16505V4.19691C17 3.079 17 2.5192 16.7822 2.0918C16.5905 1.71547 16.2837 1.40974 15.9074 1.21799C15.4796 1 14.9203 1 13.8002 1H4.2002C3.08009 1 2.51962 1 2.0918 1.21799C1.71547 1.40974 1.40974 1.71547 1.21799 2.0918C1 2.51962 1 3.08009 1 4.2002V8.16504C1 14.7333 5.9678 17.6781 8.07395 18.6314C8.29723 18.7325 8.40942 18.7829 8.66214 18.8263C8.82154 18.8537 9.17946 18.8537 9.33887 18.8263C9.59071 18.7831 9.70174 18.7328 9.92348 18.6324L9.92578 18.6314Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgShield;
